import Highlighter from 'react-highlight-words';
import React from 'react';
import truncate from 'lodash/truncate';
import { Feed, Icon, Image, Label } from 'semantic-ui-react';

import { ForumLink, PersonaLink, PostLink, SchoolLink } from '../../Links';
import { formatTimestamp } from '../../Utils';

const CONTENT_TEXT_LENGTH = 150;
const MAX_IMAGES_NUM = 3;

const Post = ({
  authed,
  content,
  createdAt,
  department,
  forum,
  gender,
  id,
  media,
  numComments,
  persona, // (TODO) -> should be renamed to 'persona'
  reactions,
  school, // (TODO) -> should be renamed to 'school'
  searchTerm,
  title,
  withImages,
}) => {
  const shouldDimAdultContent = forum.requires_18 && !authed;

  return (
    <Feed size="large">
      <ForumLink id={forum.id}>
        <Label
          size="small"
          color="teal"
        >
          {forum.name}
          {' '}
          (
          {forum.alias}
          )
        </Label>
      </ForumLink>
      <Feed.Event>
        <Feed.Content>
          <Feed.Summary>
            <PostLink id={id}>
              <Highlighter
                autoEscape
                searchWords={[searchTerm]}
                textToHighlight={title || '沒有標題喔'}
              />
            </PostLink>
            <Feed.Date>
              {formatTimestamp(createdAt)}
            </Feed.Date>
          </Feed.Summary>
          <Feed.Extra images>
            {
              !shouldDimAdultContent && withImages && Array.isArray(media) && media
                .slice(0, MAX_IMAGES_NUM)
                .map((m) => (
                  <Image
                    src={m.url}
                    referrerpolicy="no-referrer"
                  />
                ))
            }
          </Feed.Extra>
          <Feed.Content images>
            <Highlighter
              autoEscape
              searchWords={[searchTerm]}
              textToHighlight={truncate(content, { length: CONTENT_TEXT_LENGTH })}
            />
          </Feed.Content>
          <Feed.Meta>
            <Feed.Like>
              {
                gender === 'M' ? (
                  <Icon name="male" color="blue" />
                ) : (
                  <Icon name="female" color="pink" />
                )
              }
              {
                school && (
                  <SchoolLink id={school.id}>
                    {school.name}
                    {' '}
                    {department}
                  </SchoolLink>
                )
              }
              {
                persona && (
                  <PersonaLink id={persona.id}>
                    {persona.id}
                    {' '}
                    (
                    {persona.nickname}
                    )
                  </PersonaLink>
                )
              }
            </Feed.Like>
          </Feed.Meta>
          <Feed.Meta style={{ float: 'right' }}>
            {
              Array.isArray(reactions) && (
                reactions.map((r) => (
                  <Feed.Like floated="right">
                    <Image
                      src={r.link}
                      circular
                      inline
                      verticalAlign="bottom"
                      style={{
                        width: '16px',
                      }}
                    />
                    {' '}
                    {r.count}
                  </Feed.Like>
                ))
              )
            }
            <Feed.Like>
              <Icon color="orange" name="comment alternate outline" />
              {numComments}
            </Feed.Like>
          </Feed.Meta>
        </Feed.Content>
      </Feed.Event>
    </Feed>
  );
};

export default ({ authed, data, searchTerm }) => (
  data.length > 0 ? (
    <Feed size="large">
      {data.map((post) => (
        <Post
          authed={authed}
          key={post.id}
          searchTerm={searchTerm}
          content={post.content}
          createdAt={post.created_at}
          department={post.department}
          forum={post.forum}
          gender={post.gender}
          id={post.id}
          media={post.media}
          numComments={post.num_comments}
          persona={post.persona_meta} // (TODO) -> should be renamed to 'persona'
          reactions={post.reactions}
          school={post.school_meta} // (TODO) -> should be renamed to 'school'
          title={post.title}
          withImages={post.with_images}
        />
      ))}
    </Feed>
  ) : null
);
